<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="工作总结维护" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                            <FGCollapsiblePanel title="工作总结维护">
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="工作总结编号">
                                            <a-input ref="gzzjjlbh" v-model="editData.gzzjjlbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="总结日期" required>
                                            <a-date-picker
                                                ref="zjrq"
                                                style="width:100%"
                                                valueFormat="YYYY-MM-DD"
                                                v-model="editData.zjrq"
                                                placeholder="总结日期"
                                                aria-require
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="总结年份" required>
                                            <FGDictSelect
                                                ref="zjnf"
                                                dictNo="1111"
                                                :excludedVals="[
                                                    2021,
                                                    2020,
                                                    2019,
                                                    2018,
                                                    2017,
                                                    2016,
                                                    2015,
                                                    2015,
                                                    2015,
                                                    2014,
                                                    2013,
                                                    2012,
                                                    2011,
                                                    2010,
                                                    2009,
                                                    2008,
                                                    2007,
                                                    2006,
                                                    2005,
                                                    2004
                                                ]"
                                                v-model="editData.zjnf"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="单位编号">
                                            <a-input ref="dwbh" v-model="editData.dwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="单位名称" required>
                                            <a-input ref="dwmc" v-model="editData.dwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="单位类型">
                                            <a-input ref="dwlx" v-model="editData.dwlx" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="单位类别" required>
                                            <a-input ref="dwlb" v-model="editData.dwlb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="区域编号">
                                            <a-input ref="qybh" v-model="editData.qybh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="区域名称">
                                            <a-input ref="qymc" v-model="editData.qymc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="行业分类">
                                            <a-input ref="hyfl" v-model="editData.hyfl" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="单位性质">
                                            <a-input ref="dwxz" v-model="editData.dwxz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrr" v-model="editData.lrr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入日期">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="18">
                                        <a-form-item label="总结内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" required>
                                            <a-textarea ref="zjnr" :rows="3" v-model="editData.zjnr" placeholder="以附件形式上传" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="18">
                                        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <!-- 操作日志 -->
                            <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload ref="AttachUpload" :isnew="editData.isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "GzzjwhEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            dwxxData: {},
            editDataLoading: false,
            isShow_zxdwxx: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                visible: false,
                fktable: "NJ_GZZJJL",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "NJ2000"
            };
        }
    },
    activated() {
        if (!this.editDataId) {
            // 新增，设置默认值
            this.editData = {
                id: this.$FG_util.uuid(),
                isnew: true,
                djzt: "制定",
                gzzjjlbh: "",
                djlxid: "GZZJJL",
                bmid: this.getUserInfo.org_id,
                ryid: this.getUserInfo.personnel_id,
                yhid: this.getUserInfo.id,
                lrbmmc: this.getUserInfo.org_name,
                lrr: this.getUserInfo.personnel_name,
                lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                //根据当前用户单位信息设置默认值
                dwid: this.getUserInfo.companyInfo.id,
                dwbh: this.getUserInfo.companyInfo.dwbh,
                dwmc: this.getUserInfo.companyInfo.dwmc,
                dwlx: this.getUserInfo.companyInfo.dwlx,
                dwlb: this.getUserInfo.companyInfo.dwlb,
                qyid: this.getUserInfo.companyInfo.qyid,
                qybh: this.getUserInfo.companyInfo.qybh,
                qymc: this.getUserInfo.companyInfo.qymc,
                dwxz: this.getUserInfo.companyInfo.dwxz,
                zjnf: 2022
            };
            this.$FG_helper.handleNewBillCode("GZZJJLBH").then((val) => {
                this.editData.gzzjjlbh = val;
            });
        } else {
            this.loadData();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.zjrq.focus();
        });
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/gzzjgl/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        //提交form
        onSave(btnType) {
            // 表单校验
            if (btnType === 1) {
                if (!this.editData.zjrq) {
                    this.$FG_message.error("P0001", "总结日期").then(() => this.$refs.zjrq.focus());
                    return;
                }
                if (!this.editData.zjnf) {
                    this.$FG_message.error("P0001", "总结年份").then(() => this.$refs.zjnf.focus());
                    return;
                }
                // if (!this.editData.zjnr) {
                //     this.$FG_message.error("P0001", "总结内容").then(() => this.$refs.zjnr.focus());
                //     return;
                // }
                if (!this.$refs.AttachUpload.haveFile()) {
                    this.$FG_message.error("请上传总结内容附件！");
                    return;
                }
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/gzzjgl/save",
                    {
                        data: this.editData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        if (btnType === 1) {
                            this.submit();
                        }
                    } else {
                        this.$refs.zjrq.focus();
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/dwdcgl/gzzjgl/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.zjrq.focus();
                            }
                        });
                }
            });
        },

        // 返回列表
        onBack() {
            this.editIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
